import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import TestDetails from './testDetails';

export default class AddTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            errors: []
        };
    }

    handleShow = () => {
        this.setState({ show: true }, () => {
            let elements = document.getElementsByClassName('removeTabIndexModal');
            if (elements.length) {
                for (let i = 0; i < elements.length; i++) {
                    let dialog = elements[i];
                    dialog.parentNode.removeAttribute('tabindex');
                }
            }
        });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div>
                <button className="btn btn-primary button-info-grid" onClick={() => this.handleShow()}>
                    <i className="fas fa-plus"></i> Add Test
                </button>
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    dialogClassName="removeTabIndexModal"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Test Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TestDetails context={this.props.context} handleClose={this.handleClose} />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
